/** Renders API setupSteps from manual / embedded connect responses. */
const SetupStepsList = ({ steps = [], compact = false }) => {
  if (!steps?.length) return null;

  return (
    <ul className={`space-y-2 ${compact ? "text-xs" : "text-sm"}`}>
      {steps.map((step, i) => {
        const isSuccess = step.status === "success";
        const isFailed = step.status === "failed";
        return (
          <li
            key={`${step.step}-${i}`}
            className={`flex items-start gap-2 rounded-xl px-3 py-2 ${
              isSuccess
                ? "bg-emerald-50 border border-emerald-100"
                : isFailed
                ? "bg-red-50 border border-red-100"
                : "bg-gray-50 border border-gray-100"
            }`}
          >
            <span className="flex-shrink-0 mt-0.5">
              {isSuccess ? (
                <svg className="w-4 h-4 text-emerald-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              ) : isFailed ? (
                <svg className="w-4 h-4 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              ) : (
                <span className="w-4 h-4 rounded-full border-2 border-gray-300 inline-block" />
              )}
            </span>
            <div className="min-w-0 flex-1">
              <p className={`font-medium ${isFailed ? "text-red-800" : isSuccess ? "text-emerald-800" : "text-gray-700"}`}>
                {step.label || step.step}
              </p>
              {(step.message || step.error) && (
                <p className={`mt-0.5 ${isFailed ? "text-red-600" : "text-gray-500"}`}>
                  {step.message || step.error}
                </p>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default SetupStepsList;
